import { FC, PropsWithChildren } from "react";
import styled from "styled-components";

import { blueGreyMui } from "@ryde/theme";

const HeaderSimpleRidesWrapper = styled.div`
  color: ${blueGreyMui._500};
  display: flex;
  align-items: center;
  height: 18px;
`;

export const HeaderSimpleRides: FC<PropsWithChildren> = ({ children }) => {
  return <HeaderSimpleRidesWrapper>{children}</HeaderSimpleRidesWrapper>;
};
